import { Crop } from 'react-image-crop';
import { buildParams } from '../../helpers/path';
import { DefaultRequest } from '../../types/props';
import { managerApiUrl } from './manager-api';
import { baseFetch } from './utils.ts/base-fetch';

const baseUrl = 'qr-template';

export type QrTemplateType = {
  id: string;
  image: string;
  name: string;
  crop?: Crop;
};

export const fetchQrTemplates = async (params?: DefaultRequest): Promise<QrTemplateType[]> => {
  const response = await baseFetch(`${managerApiUrl}/${baseUrl}${buildParams(params || {})}`);
  return response?.qr_templates;
};

export const postQrTemplates = async (params: Partial<QrTemplateType>): Promise<QrTemplateType> => {
  const response = await baseFetch(`${managerApiUrl}/${baseUrl}`, {
    method: 'POST',
    body: JSON.stringify(params),
  });
  return response;
};

export const putQrTemplates = async (params: Partial<QrTemplateType>): Promise<QrTemplateType> => {
  const response = await baseFetch(`${managerApiUrl}/${baseUrl}/${params.id}`, {
    method: 'PUT',
    body: JSON.stringify(params),
  });
  return response;
};

export const deleteQrTemplates = async (id: string): Promise<void> => {
  const response = await baseFetch(`${managerApiUrl}/${baseUrl}/${id}`, {
    method: 'DELETE',
  });
  return response;
};
